export default {
  methods: {
    async serverErrReset() {
      await this.setError(null)
      this.$bus.$emit('input.clearServerErr')
    }
  }
}
